module.exports = __webpack_public_path__ + "img/sergeant-service-icon3.7b1b0b13.png";